<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="选择车辆" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle">
			<span slot="title" class="flex flex-middle">
				<div class="title">选择车辆</div>
				<div class="flex ml15">
					<el-input v-model.trim="licensePlate" class="w190" size="small" placeholder="车牌号" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
				</div>
			</span>
			<div class="form-box">
				<el-table class="" ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :data="tableData"
					height="300" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
					@row-click="handleRowClick" border style="width: 100%">
					<el-table-column width="60" label="选择" align="center">
						<template slot-scope="scope">
							<el-radio v-model="selecteId" :label="scope.row.carId" @change="radioRow(scope.row)">
							</el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="licensePlate" label="车牌号">
					</el-table-column>
					<el-table-column prop="carName" label="车辆名称">
					</el-table-column>
					<el-table-column prop="etcCode" label="ETC编码">
					</el-table-column>
				</el-table>

			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				licensePlate: "",
				tableData: [],
				pageNo: 1,
				pageSize: 10,
				totalPage: 0,
				multipleSelection: [],
				newFlag: "",
				selecteId: '',
				groupId: "",
				infiniteFlag: false,
			}
		},
		created() {

		},
		methods: {
			init(dt) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.infiniteFlag = false
					this.licensePlate = ""
					this.pageNo = 1
					this.groupId = dt.groupId
					this.getCarList()
					this.selecteId = dt.carId ? dt.carId : '';
				})
			},

			//  获取列表
			getCarList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"carInfoList",
						false, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							licensePlate: that.licensePlate,
							groupId: that.groupId
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
							}
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data && res.data.list || []);
						} else {
							if (res.data && res) {
								that.tableData = res.data.list
							} else {
								that.tableData = []
							}
						}
					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getCarList('scroll');
			}, 100, true),
			// 当前页切换
			handleCurrentChange(val) {
				this.pageNo = val;
				this.getCarList();
			},
			// 搜索
			handleSearch() {
				this.pageNo = 1;
				this.infiniteFlag = false;
				this.getCarList();
				if (this.tableData.length > 0) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}
			},

			// 列单选
			radioRow(val) {
				this.multipleSelection = [];
				this.multipleSelection.push(val)
			},
			// 点击行选中
			handleRowClick(row, column, event) {
				this.selecteId = row.carId;
				this.multipleSelection = [];
				this.multipleSelection.push(row)
			},
			// 保存
			submitForm: debounce(function () {
				this.$emit("selectCarRows", this.multipleSelection)
				this.dialogVisible = false
			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

</style>
